
export const UI_TOGGLE = 'UI_TOGGLE';
export const UI_SORT = 'UI_SORT';
